import { render } from "./MultiviewTeamPermissionError.vue?vue&type=template&id=7f88b0ff"
import script from "./MultiviewTeamPermissionError.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiviewTeamPermissionError.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Multiview/MultiviewTeamPermissionError.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f88b0ff"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f88b0ff', __exports__)) {
    api.reload('7f88b0ff', __exports__)
  }
  
  module.hot.accept("./MultiviewTeamPermissionError.vue?vue&type=template&id=7f88b0ff", () => {
    api.rerender('7f88b0ff', render)
  })

}


export default __exports__